export default __webpack_public_path__ + "static/media/lock_icon.0267c490.svg";